import { string, shape } from 'prop-types';
import SourcePropType from './SourcePropType';

//TODO: move to polymer
export default shape({
  source: SourcePropType,
  layer: shape({
    title: string.isRequired
  })
});
